var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtility1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_3550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 29.5555H29.5556L38 38H0V29.5555Z",
    fill: "#34A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 38V4.98828L8.44444 13.5111V38H0Z",
    fill: "#34A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H38V8.44444H8.44444L0 0Z",
    fill: "#34A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5547 24.4924V0.00378418H37.9991V33.0572L29.5547 24.4924Z",
    fill: "#34A9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_3550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtility1);
export default __webpack_public_path__ + "static/media/utility1.a2cb385340dcf7e4abbbbc336932d68d.svg";
export { ForwardRef as ReactComponent };